import { c as _c } from "react/compiler-runtime";
import type { ApiGroupOwnsNft } from "@/generated/models/ApiGroupOwnsNft";
import type { NFTSearchResult } from "@/components/header/header-search/HeaderSearchModalItem";
import GroupCreateNftSearch from "./GroupCreateNftSearch";
export default function GroupCreateNftsSelect(t0) {
  const $ = _c(3);
  const {
    selected,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== onSelect || $[1] !== selected) {
    t1 = <GroupCreateNftSearch onSelect={onSelect} selected={selected} />;
    $[0] = onSelect;
    $[1] = selected;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}